/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit WaitingTime/view.blocks to change it.
import React from 'react'
import TysiaIconHourglassBottom from 'DesignSystem/Svgs/TysiaIconHourglassBottom/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagIcon from 'DesignSystem/TysiaTag/TysiaTagIcon/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function WaitingTime({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Waiting/Appointments/Content/Appointment/WaitingTime",
  isOver20Min,
  isOver10Min,
  waitingTime
  
}) {
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type={isOver20Min ? "red" : isOver10Min ? "orange" : "grey"}
 style={isOver20Min ? "filled" : "outline"}
>
{childProps => (
<React.Fragment>
<TysiaTagIcon
{...childProps}
  viewPath={`${viewPath}/TysiaTagIcon`}
 type={isOver20Min ? "red" : isOver10Min ? "orange" : "grey"}
>
{childProps => (
<TysiaIconHourglassBottom
{...childProps}
  viewPath={`${viewPath}/TysiaIconHourglassBottom`}
 width={12}
 height={12}
/>
)}
</TysiaTagIcon>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text={waitingTime}
/>
</React.Fragment>
)}
</TysiaTag>
{children}
</React.Fragment>)
}